import React, { createElement, useContext, useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import CreateAuctionLinechart from "./components/CreateAuctionLinechart";
import TotalAuctionStatus from "./components/TotalAuctionStatus";
import RightAsideComponent from "./rightAside/RightAsideComponent";
import ButtonAnimation from "../../../Resusable/ButtonAnimation";
import { globalContext } from "../../../context/ContextProvider";
import { auctionTableComponents } from "../../../helpers/auctionTable";
import AuctionFilter from "../../commanPage/searchAndFilter/AuctionFilter";
import AuctionSearch from "../../commanPage/searchAndFilter/AuctionSearch";

function HomePage() {
  const { sellerHomePageButton, setSellerHomePageButton } =
    useContext(globalContext);
  const [searchData, setSearchData] = useState("");
  const isDastop = useMediaQuery({ query: "(max-width: 1420px)" });
  const isLaptop = useMediaQuery({ query: "(max-width: 1050px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 886px)" });
  const [auctionFilter, setAuctionFilter] = useState("");

  useEffect(() => {
    setSearchData("");
  }, [sellerHomePageButton]);

  return (
    <div className="flex gap-1  border-radius-12">
      <div
        className=""
        style={{
          width: isTablet
            ? "100%"
            : isLaptop
              ? "66%"
              : isDastop
                ? "72%"
                : "78.5%",
        }}
      >
        <div className={`flex gap-1 ${isDastop ? "column" : ""} `}>
          <TotalAuctionStatus />
          <CreateAuctionLinechart />
        </div>
        {isTablet && <RightAsideComponent />}
        <h4 className="mt-2 font-cercular-bold">Auction Details</h4>
        <div className="valign-wrapper space-between flex-wrap mt-1">
          <ButtonAnimation
            buttonPosition={sellerHomePageButton}
            setButtonPosition={setSellerHomePageButton}
          />
          <div className="valign-wrapper gap-1">
            <span
              className="input-field-style"
              style={{
                height: "40px",
                width: "220px",
                marginBottom: isDastop ? "1.3rem" : "1rem",
                marginTop: "0px"
              }}
            >
              <img src="/images/urlIcon.png" alt="auctionLogo" width={25} />
              <AuctionFilter setAuctionFilter={setAuctionFilter} />
            </span>
            <div
              className="input-field-style "
              style={{
                height: "40px",
                width: "250px",
                marginBottom: isDastop ? "1.3rem" : "1rem",
                marginTop: "0px"
              }}
            >
              <AuctionSearch
                searchData={searchData}
                setSearchData={setSearchData}
                placeholder={"Search"}
              />
            </div>
          </div>
        </div>

        {auctionTableComponents[sellerHomePageButton] &&
          createElement(auctionTableComponents[sellerHomePageButton], {
            searchData: searchData,
            auctionFilter: auctionFilter,
          })}
      </div>
      {!isTablet && <RightAsideComponent />}
    </div>
  );
}

export default HomePage;
